import {createScriptTag, IPageObserverEntry} from './Helper.client';

let isScrolled: boolean = false;
const target: HTMLElement | null = document.querySelector('.AboveTheFold');

export const aboveTheFoldObserver = (onIntersected?: (target: Element) => void): IPageObserverEntry | null => {
    if (target === null) {
        return target;
    }

    return {
        element: target,
        callback: (entry: IntersectionObserverEntry): void => {
            if (
                isScrolled !== true &&
                entry.target.getBoundingClientRect().top < 0
            ) {
                isScrolled = true;
                createScriptTag(null, 'https://wchat.freshchat.com/js/widget.js', () => {
                    createScriptTag(`
                        window.fcWidget.init({
                                token: "d11539bc-c189-4fc7-896b-4eaca3dba929",
                                host: "https://wchat.freshchat.com",
                                siteId: "vroom",
                                tags: ["vroom-au"],
                                config: {
                                    hideFAQ: true,
                                }
                        });
                    `);
                });
            }

            if (typeof onIntersected !== 'undefined') {
                onIntersected(entry.target);
            }
        },
        threshold: [0.1, 0.25]
    }
}
